query GetTargetAudiences {
  targetAudiences {
    id
    name
    filters {
      id
      filterType
      recordType
      record
    }
  }
}
